export const SuccessIcon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.5302 9.25634C17.8457 9.58706 17.8334 10.1109 17.5026 10.4264L11.43 16.2197C11.1101 16.525 10.6067 16.5248 10.287 16.2192L7.25583 13.3226C6.92538 13.0068 6.91349 12.4829 7.22928 12.1525C7.54507 11.822 8.06895 11.8101 8.3994 12.1259L10.8592 14.4766L16.3601 9.22879C16.6908 8.91329 17.2147 8.92562 17.5302 9.25634Z'
        fill='currentColor'
      />
    </svg>
  )
}
